export function getUserTasks(userId: string) {
    const requestOptionsGet = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    return fetch(import.meta.env.VITE_API_URL + '/v1/task?userId=' + userId, requestOptionsGet);
}

export function getTaskExamples() {
    const requestOptionsPost = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    return fetch(import.meta.env.VITE_API_URL + '/v1/examples/', requestOptionsPost)
}

export function getSharedTasksConcrete(userId: string) {
    const requestOptionsPost = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    return fetch(import.meta.env.VITE_API_URL + '/v1/task-shares/concrete/' + userId, requestOptionsPost)
}

export function getSharedTasksGroups(userId: string) {
    const requestOptionsPost = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    return fetch(import.meta.env.VITE_API_URL + '/v1/task-shares/groups/' + userId, requestOptionsPost);
}